import { IFormSubmitService } from './IFormSubmitService';
import axios from 'axios'

export default class FormAdminService implements IFormSubmitService {

  private rootUrl = (): string =>
    process.env.VUE_APP_API_BASE_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '')

  async submitForm(id: string = "foo", data: object): Promise<object> {
    try {
      const response = await axios.post(this.rootUrl() + `/submitFormData?id=${id}`, data)
      return response.data;
    } catch (error: any) {
      console.log('error.message', error.message)
      if (error.response) {
        return error.response.data
      }
      return error
    }
  }

  async getForm(id: string = 'foo'): Promise<object> {
    const response = await axios.get(this.rootUrl() + `/formStructure?id=${id}`)
    return response.data;
  }

  async submitReCaptcha(value: string): Promise<object> {
    const response = await axios.post(this.rootUrl() + `/verifyRecaptcha`, {
      'g-recaptcha-response': value
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  }

  // Nieuwe methode om gerelateerde records op te halen.
  async getRelatedRecords(collectionPath: string, labelField: string, valueField: string = 'id', formConfigPath?: string): Promise<any[]> {
    try {
      const url = this.rootUrl() + `/api/related-data`;
      const response = await axios.post(url, {
        collectionPath,
        labelField,
        valueField,
        formConfigPath
      });

      return response.data.map((item: any) => ({
        text: { nl: item[labelField], en: item[labelField] }, // Ondersteuning voor meertaligheid
        value: item[valueField]
      }));
    } catch (error: any) {
      console.log('API error bij ophalen van gerelateerde records:', error);
      return [];
    }
  }
}